
import VacanciesFeedbackForm from '~/components/vacancies/VacanciesFeedbackForm.vue';
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  name: 'VacanciesFeedbackFormBlock',
  components: {
    VacanciesFeedbackForm,
  },
  computed: {
    localValues: function () {
      return this.externalData?.VacanciesFeedbackFormBlock || this.values || {}; // @FIXME ПРОВЕРЬ!
    },
  },
});
